import { render, staticRenderFns } from "./UserOrderManage.vue?vue&type=template&id=2e4be97d&scoped=true&"
import script from "./UserOrderManage.vue?vue&type=script&lang=js&"
export * from "./UserOrderManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4be97d",
  null
  
)

export default component.exports